<template>
  <v-skeleton-loader
    :boilerplate="false"
    :type="type"
    :tile="false"
    :loading="skLoading"
    transition="fade-transition"
    class="mx-auto"
  >
    <slot></slot>
  </v-skeleton-loader>
</template>

<script>
/**
 * @params skLoading  加载骨屏
 * @params type  骨架屏的类型
 */
export default {
  components: {},
  props: {
      skLoading:{
          type: Boolean,
          default: false
      },
      type: {
          type: String,
          default: 'table-tbody'
      }
  },
  data() {
    return {

    };
  },
  created() {},
  mounted() {},
  methods: {

  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
</style>
